import React from 'react';
import { ExternalLink, Gift, CheckCircle, ArrowRight } from 'lucide-react';

const offers = [
  {
    id: 1,
    name: 'NetBet',
    url: 'https://www.netbet.fr/',
    bonus: 'Bonus de bienvenue de 100€',
    description: 'Une plateforme reconnue avec une sélection impressionnante de paris sportifs et des cotes compétitives. Pariez en toute confiance avec un bonus qui double votre première mise.',
    features: ['Paris en direct', 'Cash out disponible', 'Application mobile', 'Retraits rapides'],
    image: '/images/john-fornander-y6_SJpU3Alk-unsplash.webp',
    color: 'from-blue-600 to-blue-800',
    textColor: 'text-blue-400',
  },
  {
    id: 2,
    name: 'UniBet',
    url: 'https://www.unibet.fr/',
    bonus: '10€ de dépôt gratuit + 100€ de bonus',
    description: 'Démarrez votre expérience sans risquer un centime. Profitez de 10€ offerts dès l\'inscription, puis multipliez vos gains avec un bonus de 100€ supplémentaire. Une offre exclusive pour nouveaux parieurs.',
    features: ['10€ gratuit immédiat', 'Interface intuitive', 'Streaming en direct', 'Support 24/7'],
    image: '/images/eduard-labar-9lOrwiZ3W4k-unsplash.webp',
    color: 'from-green-600 to-green-800',
    textColor: 'text-green-400',
  },
  {
    id: 3,
    name: 'Vbet',
    url: 'https://vbet.fr/',
    bonus: 'Bonus de bienvenue de 100€',
    description: 'Un opérateur de confiance avec des années d\'expérience. Rejoignez une communauté de parieurs qui profitent de promotions régulières et d\'une plateforme fiable pour leurs mises.',
    features: ['Promotions régulières', 'Cotes boostées', 'VIP Club exclusif', 'Paiements sécurisés'],
    image: '/images/peter-glaser-qWs_Wa1JrKM-unsplash.webp',
    color: 'from-purple-600 to-purple-800',
    textColor: 'text-purple-400',
  },
];

const Offers = () => {
  return (
    <section id="offres" className="py-20 bg-gray-800">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            <span className="bg-gradient-to-r from-pink-400 to-pink-600 bg-clip-text text-transparent">
              Offres Exclusives
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Des bonus soigneusement sélectionnés pour maximiser vos chances de gagner dès le premier pari
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {offers.map((offer, index) => (
            <div
              key={offer.id}
              className={`bg-gray-900 rounded-2xl overflow-hidden border-2 border-transparent hover:border-pink-600 transition-all duration-300 transform hover:-translate-y-2 ${
                index === 1 ? 'lg:scale-105 lg:border-pink-600' : ''
              }`}
            >
              {/* Image */}
              <div className="h-48 relative overflow-hidden">
                <img 
                  src={offer.image} 
                  alt={offer.name} 
                  className="w-full h-full object-cover"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${offer.color} opacity-80`}></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="text-white text-2xl font-bold drop-shadow-lg">{offer.name}</div>
                </div>
                <div className="absolute top-4 right-4">
                  <span className="bg-black/60 backdrop-blur-sm px-3 py-1 rounded-full text-white text-sm font-semibold flex items-center space-x-1">
                    <Gift size={14} />
                    <span>Bonus</span>
                  </span>
                </div>
              </div>

              <div className="p-6" itemScope itemType="https://schema.org/Offer">
                <div className="mb-4">
                  <h3 className="text-2xl font-bold text-white mb-2" itemProp="name">{offer.name}</h3>
                  <p className={`${offer.textColor} font-semibold flex items-center space-x-2 mb-3`} itemProp="description">
                    <Gift size={18} />
                    <span>{offer.bonus}</span>
                  </p>
                  <p className="text-gray-400 text-sm leading-relaxed" itemProp="description">
                    {offer.description}
                  </p>
                </div>

                <div className="mb-6">
                  <ul className="space-y-2">
                    {offer.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center space-x-2 text-gray-300 text-sm">
                        <CheckCircle size={16} className={`${offer.textColor} flex-shrink-0`} />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <a
                  href={offer.url}
                  target="_blank"
                  rel="noopener noreferrer nofollow sponsored"
                  className={`block w-full py-3 px-6 bg-gradient-to-r ${offer.color} text-white rounded-lg font-semibold text-center hover:opacity-90 transition-all flex items-center justify-center space-x-2 group`}
                >
                  <span>Rejoindre {offer.name}</span>
                  <ExternalLink size={18} className="group-hover:translate-x-1 transition-transform" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offers;

